import { customAxios } from '../../common/customAxios';
import { createURLSearchParams } from '../../../utils/creator/createURLSearchParams.util';
import { IMarketPrice } from '../../../interfaces/MarketPrice.interfaces';

export const machinePriceStatisticsApiUrl = '/machine-price-statistics';

export interface IGetMachinePriceStatisticsParams {
  searchParam: {
    brand?: string;
    minEngineOutputPs: number;
    maxEngineOutputPs: number;
    minMedianPrice: number;
    maxMedianPrice: number;
    sort: string;
    count: number;
    page: number;
  };
}

export const getMachinePriceStatistics = ({
  searchParam,
}: IGetMachinePriceStatisticsParams): Promise<IMarketPrice[]> => {
  const URLSearchParams = createURLSearchParams(searchParam ?? {});
  return customAxios.get(`${machinePriceStatisticsApiUrl}?${URLSearchParams}`);
};
